import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const GroupTeamDetailsPage = withSuspense(
	lazy(async () => await import('./group-team-details-page.component')),
	PageLoader,
);
